import { IconButton, Icon } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate, Route, Routes } from "react-router-dom";
import { FileTypeEnum } from "../../_common/enum";
import { FileStateEnum } from "../../_common/enum/fileUploadState.enum";
import { StandardPanel } from "../../_components/panel/standard.panel";
import { StandardTable } from "../../_components/table/standard.table";
import { toastr } from "../../_components/toastr/toastr";
import { TABLE_FILTER } from "../../_const/tableFilter.const";
import { getDateString } from "../../_helpers/dateTime.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { fileUploadService } from "../../_services/fileUpload.service";
import { CentreFileManageDrawer } from "../centre/components/centre-filePanelManageDrawer";
import { DocumentManageDrawer } from "./document-manage";


export function DocumentIndex(params: { fileTypeId: number, title: string }) {
    const [isLoading, setIsLoading] = useState(false);
    const [filter, setFilter] = useState<any>({ ...TABLE_FILTER, pageSize: "10", orderBy: "" });
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, []);


    function fetchData() {
        setIsLoading(true);
        return fileUploadService.getAll(params.fileTypeId)
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    }


    function download(id: string) {
        return fileUploadService.download(id, params.fileTypeId);
    }


    function disable(id: string) {
        if (!id) return;
        setIsLoading(true);

        return fileUploadService
            .disable(id)
            .then(
                () => {
                    toastr.success("File deleted successfully");
                    fetchData();
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: '',
                size: 1,
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                Cell: ({ row }) => (<>
                    <IconButton
                        color="primary"  sx={{ mr: 2 }}
                        onClick={() => { download(row.original.fileUploadId) }}>
                        <Icon>download</Icon>
                    </IconButton>
                    <IconButton
                        color="primary" 
                        onClick={() => { disable(row.original.fileUploadId) }}>
                        <Icon>delete</Icon>
                    </IconButton>
                </>
                ),
            },
            {
                size: 2,
                accessorKey: 'fileName',
                header: 'File Name',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
            },
            {
                size: 2,
                accessorKey: 'uploadedBy',
                header: 'Uploaded By',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,

            },
            {
                size: 2,
                accessorKey: 'uploadedDate',
                header: 'Uploaded On',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                Cell: ({ row }) => (
                    <>{!!row.original.uploadedDate ? getDateString(row.original.uploadedDate) : ""}</>
                ),
            },
            {
                accessorKey: 'state',
                header: 'Status',
                size: 2,
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                accessorFn: (rowData: any) => <>
                    {rowData.state !== null ? FileStateEnum[rowData.state] : ""}
                </>
            },

        ],
        []
    );

    return (
        <>
            <StandardPanel
                title={params.title}
                buttons={[
                    { icon: "add", onClick: () => { navigate("ManageFileUpload") } },
                ]} loading={isLoading}>


                <StandardTable columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={setFilter}
                    loading={isLoading}></StandardTable>
            </StandardPanel>

            <Routes>
                <Route path="ManageFileUpload" element={<DocumentManageDrawer fileTypeId={params.fileTypeId.toString()} onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate(""); fetchData(); }} />} />
            </Routes>

        </>
    );
};

export function ResourceDocumentIndex() { return <DocumentIndex fileTypeId={FileTypeEnum.ResourceDocument} title="Resource Documents" />; }

export function PolicyDocumentIndex() { return <DocumentIndex fileTypeId={FileTypeEnum.PolicyDocument} title="Policy Documents" />; }